import React from 'react';
import './svg.css';

const NewUploadSpeedIcon = () => {
  return (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" fill="white" />
      <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" stroke="#C9CCD4" strokeWidth="0.6" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.5449 9.91762C14.7402 10.1129 15.0567 10.1129 15.252 9.91762C15.4473 9.72235 15.4473 9.40577 15.252 9.21051L12.352 6.31051C12.1567 6.11525 11.8402 6.11525 11.6449 6.31051L8.7449 9.21051C8.54963 9.40577 8.54963 9.72235 8.7449 9.91762C8.94016 10.1129 9.25674 10.1129 9.452 9.91762L11.4961 7.87351V14.4C11.4961 14.6761 11.72 14.9 11.9961 14.9C12.2722 14.9 12.4961 14.6761 12.4961 14.4V7.86883L14.5449 9.91762Z" fill="url(#paint0_radial_5148_1280)" />
      <path d="M19.25 14.3984V15.3651C19.25 16.4329 18.3844 17.2984 17.3167 17.2984H6.68333C5.61558 17.2984 4.75 16.4329 4.75 15.3651V14.3984" stroke="url(#paint1_radial_5148_1280)" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <radialGradient id="paint0_radial_5148_1280" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.1053 17.1888) rotate(-127.774) scale(16.2244 53.4461)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient id="paint1_radial_5148_1280" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(22.8895 18.0582) rotate(-168.641) scale(21.6151 28.3971)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>

  )
}

export default NewUploadSpeedIcon;